/**
 * Constants for `chart`.
 *
 * @module @shared/constants
 */

// Format: { THEME_NAME: CSS_SELECTOR }
export const THEMES = { light: '', dark: '.dark' } as const;
